let config = {
  emailjs: {
    serviceID: "service_llmgfmk",
    templateID: "template_zmh29wn",
    userID: "MWFq8f7-C_8OX4m1Q",
  },
};

export default config;
